import { Component } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { UtilsService } from '../../../../../services/utils/utils.service';

@Component({
  selector: 'app-rdsap-appendix',
  templateUrl: './appendix.component.html',
})
export class AppendixComponent {
  technologyForm: FormGroup;

  constructor(private fb: FormBuilder, private utilsService: UtilsService,) {
    this.technologyForm = this.fb.group({
      appendixQDescription: [''],
      specialFeatureTypeEmissions: [''],
      appendixQEmissionsSaved: [''],
      appendixQEmissionsCreated: [''],
      specialFeatureTypeEnergy: [''],
      appendixQEnergySaved: [''],
      appendixQEnergySavedFuel: [''],
      appendixQEnergyUsed: [''],
      appendixQEnergyUsedFuel: [''],
      appendixQEnergyAirChangeRates: [false],
      appendixQEnergyAirChangeRateMonth: this.fb.array(this.initAirChangeRateMonths())
    });
  }

  get airChangeRateMonths() {
    return this.technologyForm.get('appendixQEnergyAirChangeRateMonth') as FormArray;
  }

  get isEmissionsFeatureSelected(): boolean {
    return !!this.technologyForm.get('specialFeatureTypeEmissions').value;
  }

  get isEnergyFeatureSelected(): boolean {
    return !!this.technologyForm.get('specialFeatureTypeEnergy').value;
  }

  filterLookupCodes(filter) {
    return this.utilsService.filterLookupCodes(filter);
  }

  private initAirChangeRateMonths(): FormGroup[] {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return months.map((month) => this.fb.group({
      month: [month],
      airChangeRateValue: ['']
    }));
  }
}
